/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

export interface FormatterOptions {
  [key: string]: any;
}

export interface Formatter {
  format(value: any): string;
  parse(value: string): any;
  // TODO: replace clone
  clone(options: FormatterOptions): Formatter;
}

export class FormatterProvider {
  private static readonly formatterFacotryMap = new Map<string, (options?: FormatterOptions) => Formatter>();
  private static readonly formatterMap = new Map<string, Formatter>();

  static registerFormatterFactory(formatterKey: string, formatterFactory: (options?: FormatterOptions) => Formatter) {
    FormatterProvider.formatterFacotryMap.set(formatterKey, formatterFactory);
  }

  static resolveFormatterFactory(formatterKey: string): (options?: FormatterOptions) => Formatter {
    return FormatterProvider.formatterFacotryMap.get(formatterKey);
  }

  static registerFormatter(formatKey: string, formatter: Formatter) {
    FormatterProvider.formatterMap.set(formatKey, formatter);
  }

  static resolveFormatter(formatKey: string, options?: FormatterOptions): Formatter {
    let formatter: Formatter = FormatterProvider.formatterMap.get(formatKey);
    if (formatter) {
      return options ? formatter.clone(options) : formatter;
    }
    const optionsMatch = /^([^?]+)(\?\S.*)$/.exec(formatKey);
    if (!optionsMatch) {
      return undefined;
    }
    formatter = FormatterProvider.formatterMap.get(optionsMatch[1]);
    if (!formatter) {
      return undefined;
    }
    const keyOptions = {};
    const optionRegex = /[?&]([^=&]+)(?:=([^&]+))?/g;
    let optionMatch = optionRegex.exec(optionsMatch[2]);
    while (optionMatch !== null) {
      // keyArgs[optionMatch[1]] = optionMatch[2] || true;
      keyOptions[decodeURIComponent(optionMatch[1])] = decodeURIComponent(optionMatch[2]) || true;
      optionMatch = optionRegex.exec(optionsMatch[2]);
    }
    options = Object.assign(keyOptions, options);
    return formatter.clone(options);
  }

}
